<template>
  <section class="hero-image">
    <div class="hero-txt">
      <div>
        <h1 v-html="$t(`home.sloganTitle${index}`)"></h1>
        <p>{{ $t(`home.sloganDescription${index}`) }}</p>
      </div>

      <div class="great-offers">
        <b-form inline @submit.prevent="findPlaces">
          <b-input-group>
            <div class="relative">
              <b-form-input
                id="inline-form-input-name"
                class="banner-input-rule"
                autocomplete="off"
                :placeholder="$t('home.goingWhere')"
                :value="location.destination"
                readonly
                @click="$refs.typesenseSearch.show()"
              ></b-form-input>
              <TypesenseSearch ref="typesenseSearch" @select="setLocation" />
            </div>
            <b-button type="submit" variant="primary" class="find">{{
              $t("home.findOffers")
            }}</b-button>
          </b-input-group>
        </b-form>
      </div>
    </div>
  </section>
</template>

<script>
import TypesenseSearch from "@/components/Widgets/TypesenseSearch";

export default {
  name: "HeroSection",
  data() {
    return {
      index: 1,
      location: {
        destination: "",
        latitude: 0,
        longitude: 0,
      },
    };
  },
  components: {
    TypesenseSearch,
  },
  mounted() {
    this.index = Math.floor(Math.random() * 3) + 1;
  },
  methods: {
    findPlaces() {
      let { latitude, longitude, destination, propertyId } = this.location;
      if (propertyId) {
        this.$router.push({
          path: `/listing/${propertyId}`,
          query: { list_id: this.$route.query.list_id },
        });
        return;
      }
      if (!latitude || !longitude) {
        this.$router.push({ path: "listing" });
        return;
      }
      if (!destination) {
        destination = this.$t("home.nearYou");
      }
      this.$router.push({
        path: "listing",
        query: { latitude, longitude, destination },
      });
    },
    setLocation(data) {
      this.location = data;
      setTimeout(() => this.findPlaces(), 500);
    },
  },
};
</script>

<style>
.disabled {
  color: #ddd !important;
  cursor: default;
}
.pac-container:after {
  background-image: none !important;
  height: 0;
}
</style>

<style scoped>
@media screen and (max-width: 767px) {
  .typesense-search-widget {
    top: 56px !important;
    left: 0 !important;
  }
}
</style>
